import { FC } from 'react'
import {
  StyleCard,
  StyleCardFooter,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
  StyleTag,
} from './style'
import Image from '@components/image'
import Column from '@components/column'
import Typography from '@components/typography'
import Row from '@components/row'
import Button from '@components/button'
import Svg from '@components/svg'
import { formatDistanceToNow } from 'date-fns'
interface InstantAppointmentRequestCardProps {
  styleCard?: string
  appointment?: any
}
const InstantAppointmentRequestCard: FC<InstantAppointmentRequestCardProps> = ({
  styleCard,
  appointment,
}) => {
  const timeAgo = formatDistanceToNow(appointment?.createdAt, {
    addSuffix: true,
  }).replace(/^about /, '')

  return (
    <StyleCard styleCard={styleCard}>
      <StyleCardHeader>
        <StyleLeftCardHeader>
          <Image
            src={`${process.env.BUCKET_URL}/${appointment?.patient?.avatar}`}
            styleImage="border-radius:50%;"
            width={50}
            height={50}
            fallbackType="user"
          />
          <Column rowGap={10}>
            <Typography
              content={appointment?.patient?.name}
              size={14}
              tc="text"
            />
            <Row colGap={10}>
              <StyleTag>{appointment?.patient?.infos?.gender}</StyleTag>
              <StyleTag>{appointment?.patient?.infos?.age}</StyleTag>
              <StyleTag>{appointment?.patient?.infos?.bloodGroup}</StyleTag>
            </Row>
          </Column>
        </StyleLeftCardHeader>
        <StyleRightCardHeader>
          <Column
            styleColumn="border-radius:4px;padding:5px 7px;"
            bg="primary200"
          >
            <Typography content={timeAgo} size={12} tc="primary" />
          </Column>
        </StyleRightCardHeader>
      </StyleCardHeader>
      <StyleCardFooter>
        <Button
          title="Add to Queue"
          outline
          radius={8}
          height={45}
          styleButtonWrapper="width:48%"
          styleButton="width:100%;"
          leftComponent={<Svg svg="queue" color={'primary'} />}
          data-cross-type={`queue-${appointment?.id}`}
        />
        <Button
          title="Accept Request"
          radius={8}
          height={45}
          styleButtonWrapper="width:48%"
          styleButton="width:100%;"
          data-cross-type={`confirm-${appointment?.id}`}
        />
      </StyleCardFooter>
    </StyleCard>
  )
}

export default InstantAppointmentRequestCard
